angular.module('tgaAdmin').controller('HubAnalyticsWrapperController', [
  '$scope',
  '$state',
  'gameService',
  function (
    $scope,
    $state,
    gameService,
  ) {
    $scope.showBack = false;

    $scope.data = {
      alerts: [],
      game_id: parseInt($state.params.game_id, 10) || null,
    };

    $scope.viewmodel = {
      game: {},
    };

    $scope.initialize = function () {
      $scope.loadingGame = true;

      gameService
        .getGame($scope.data.game_id)
        .then((game) => {
          $scope.viewmodel.game = game;
          $scope.loadingGame = false;
        })
        .catch(() => {
          $state.go('v1.games');
        });
    };

    $scope.initialize();
  },
]);
